import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subject, of } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, switchMap, tap } from 'rxjs/operators';
import { AutocompleteOptions } from './autocomplete-options';
import { UtilService } from './../../../core/services/util.service';

@Component({
    selector: 'app-autocomplete',
    templateUrl: './autocomplete.component.html',
    styleUrls: ['./autocomplete.component.scss'],
    standalone: false
})
export class AutocompleteComponent<T> implements OnInit, OnDestroy {

	@Input() options: AutocompleteOptions<T>;
	@Input() disabled: boolean;

	@Output() selected = new EventEmitter<any>();
	@Output() inputFocused = new EventEmitter();

	data: T[] = [];
	isLoadingResult = false;
	selectedItem: any = null;
	typeahead$ = new Subject<string>();

	private readonly onDestroy = new Subject<void>();

	ngOnInit(): void {
		this.options = {...new AutocompleteOptions(), ...this.options};

		this.typeahead$
			.pipe(
				debounceTime(300),
				distinctUntilChanged(),
				tap(() => {
					this.isLoadingResult = true;
					this.data = [];
				}),
				switchMap(term => {
					if (!term || term.length < this.options.minQueryLength) {
						this.isLoadingResult = false;
						return of([]);
					}
					return this.options.searchFn(term).pipe(
						catchError(() => of([]))
					);
				})
			)
			.subscribe(data => {
				this.data = UtilService.flattenArrayObjects(data);
				this.isLoadingResult = false;
			});
	}

	onSelect(item: any): void {
		if (item) {
			this.selected.emit(item);
			if (this.options.clearInputOnSelection) {
				this.selectedItem = null;
			}
		}
	}

	onFocus(): void {
		this.inputFocused.emit();
	}

	ngOnDestroy(): void {
		this.onDestroy.next();
	}
}
